var _rect, _path, _path2, _rect2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcBookCircle = function SvgIcBookCircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.8497V24.7397C30 25.7097 29.21 26.5997 28.24 26.7197L27.93 26.7597C26.29 26.9797 23.98 27.6597 22.12 28.4397C21.47 28.7097 20.75 28.2197 20.75 27.5097V13.5997C20.75 13.2297 20.96 12.8897 21.29 12.7097C23.12 11.7197 25.89 10.8397 27.77 10.6797H27.83C29.03 10.6797 30 11.6497 30 12.8497Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7122 12.7097C16.8822 11.7197 14.1122 10.8397 12.2322 10.6797H12.1622C10.9622 10.6797 9.99219 11.6497 9.99219 12.8497V24.7397C9.99219 25.7097 10.7822 26.5997 11.7522 26.7197L12.0622 26.7597C13.7022 26.9797 16.0122 27.6597 17.8722 28.4397C18.5222 28.7097 19.2422 28.2197 19.2422 27.5097V13.5997C19.2422 13.2197 19.0422 12.8897 18.7122 12.7097ZM13.0022 15.7397H15.2522C15.6622 15.7397 16.0022 16.0797 16.0022 16.4897C16.0022 16.9097 15.6622 17.2397 15.2522 17.2397H13.0022C12.5922 17.2397 12.2522 16.9097 12.2522 16.4897C12.2522 16.0797 12.5922 15.7397 13.0022 15.7397ZM16.0022 20.2397H13.0022C12.5922 20.2397 12.2522 19.9097 12.2522 19.4897C12.2522 19.0797 12.5922 18.7397 13.0022 18.7397H16.0022C16.4122 18.7397 16.7522 19.0797 16.7522 19.4897C16.7522 19.9097 16.4122 20.2397 16.0022 20.2397Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EBECF0"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBookCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-book-circle.68c9f4fa.svg";
export { ForwardRef as ReactComponent };